<template>
  <div class="solicitation-tab">
    <div class="content-area">
      <section class="solicitation-section">
        <div class="solicitation-details">
          <div class="location-section">
            <h3 class="section-title">
              De onde vamos sair?
            </h3>
            <div class="location-display">
              <div class="loc-card-display">
                <div
                  class="d-flex align-center"
                  style="gap: 16px;"
                >
                  <div class="loc-icon-wrapper">
                    <v-icon color="#E7E3FC">
                      {{ icons.mdiMapMarkerOutline }}
                    </v-icon>
                  </div>
                  <div>
                    <h3 class="loc-card-title">
                      {{ (solicData.departure_point && solicData.departure_point.fantasy_name) || 'Local não informado' }}
                    </h3>
                    <span class="loc-card-address">
                      {{ formatSourceAdress(solicData.departure_point).toUpperCase() }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="location-section">
            <h3 class="section-title">
              Pra onde devemos ir?
            </h3>
            <div class="location-display">
              <div class="loc-card-display">
                <div
                  class="d-flex align-center"
                  style="gap: 16px;"
                >
                  <div class="loc-icon-wrapper">
                    <v-icon color="#E7E3FC">
                      {{ icons.mdiMapMarkerOutline }}
                    </v-icon>
                  </div>
                  <div>
                    <h3 class="loc-card-title">
                      {{ (solicData.address && solicData.address.local_name) || 'Local não informado' }}
                    </h3>
                    <span class="loc-card-address">
                      {{ formatAddress(solicData.address) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="solicData.is_manual"
            class="mt-4"
          >
            <v-text-field
              :value="responsibleOfCompany.name"
              outlined
              dense
              disabled
              style="width: 100%;"
              label="Responsável"
              hide-details
            />
          </div>

          <div class="trip-form-section">
            <div class="form-group">
              <h3 class="section-title">
                Saída
              </h3>
              <div class="date-time-row">
                <v-menu
                  v-model="menuDepartureDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="departureDate ? formatDate(departureDate + 'T00:00:00') : '-'"
                      label="Data da saída"
                      :prepend-inner-icon="icons.mdiCalendar"
                      outlined
                      dense
                      class="date-field"
                      readonly
                      :disabled="!canEditGeneralFields"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="departureDate"
                    locale="pt-BR"
                    @input="menuDepartureDate = false; onFieldChange()"
                  />
                </v-menu>
                <v-menu
                  v-model="menuDepartureTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="departureTime || '-'"
                      label="Hora da saída"
                      :prepend-inner-icon="icons.mdiClockTimeEightOutline"
                      outlined
                      dense
                      class="time-field"
                      readonly
                      :disabled="!canEditGeneralFields"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-model="departureTime"
                    format="24hr"
                    locale="pt-BR"
                    @click:minute="menuDepartureTime = false; onFieldChange()"
                  />
                </v-menu>
              </div>
            </div>

            <div class="form-group">
              <h3 class="section-title">
                Retorno
              </h3>
              <div class="date-time-row">
                <v-menu
                  v-model="menuReturnDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="returnDate ? formatDate(returnDate + 'T00:00:00') : '-'"
                      label="Data do retorno"
                      :prepend-inner-icon="icons.mdiCalendar"
                      outlined
                      dense
                      class="date-field"
                      readonly
                      :disabled="!canEditGeneralFields"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="returnDate"
                    locale="pt-BR"
                    @input="menuReturnDate = false; onFieldChange()"
                  />
                </v-menu>
                <v-menu
                  v-model="menuReturnTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="returnTime || '-'"
                      label="Hora do retorno"
                      :prepend-inner-icon="icons.mdiClockTimeEightOutline"
                      outlined
                      dense
                      class="time-field"
                      readonly
                      :disabled="!canEditGeneralFields"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-model="returnTime"
                    format="24hr"
                    locale="pt-BR"
                    @click:minute="menuReturnTime = false; onFieldChange()"
                  />
                </v-menu>
              </div>
            </div>

            <div class="form-group">
              <h3 class="section-title">
                Qual o motivo
              </h3>
              <v-textarea
                :value="solicData.reason || '-'"
                label="Motivo"
                outlined
                dense
                readonly
                class="description-field"
              />
            </div>

            <div class="form-group">
              <h3 class="section-title">
                Passageiros
              </h3>
              <div class="passengers-section">
                <div
                  class="d-flex align-center add-passenger pt-4 pb-6"
                  :class="{ disabled: !canEditPassengers }"
                  @click="canEditPassengers ? handleAddPassenger() : null"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                  <h3 style="font-weight: 600; font-size: 15px;">
                    Adicionar passageiros
                  </h3>
                </div>
                <div
                  v-for="(passenger, index) in [...passengers].reverse()"
                  :key="index"
                  class="d-flex align-start"
                  style="gap: 16px;"
                >
                  <span style="font-weight: 600; font-size: 15px; color: #FF821A; padding-top: 9px;">
                    {{ passengers.length - index }}
                  </span>
                  <v-autocomplete
                    v-model="passenger.id"
                    :items="getUsersForPassengerField(passenger.id)"
                    item-text="name"
                    item-value="id"
                    style="width: 100%;"
                    outlined
                    dense
                    label="Nome do passageiro"
                    :disabled="!canEditPassengers"
                    @input="onFieldChange"
                  />
                  <v-tooltip
                    bottom
                    color="#000000a1"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="error"
                        v-bind="attrs"
                        :disabled="!canEditPassengers"
                        @click="removePassenger(passengers.length - index - 1)"
                        v-on="on"
                      >
                        <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                      </v-btn>
                    </template>
                    <span>Remover passageiro</span>
                  </v-tooltip>
                </div>
              </div>
            </div>

            <div class="form-group">
              <h3 class="section-title">
                Bagagens
              </h3>
              <v-checkbox
                v-model="hasLuggage"
                label="Possui bagagens?"
                :disabled="!canEditGeneralFields"
                class="luggage-checkbox"
                color="purple"
                @change="onFieldChange"
              />
              <v-textarea
                v-if="hasLuggage"
                v-model="luggageDetails"
                label="Detalhes das bagagens"
                outlined
                dense
                :disabled="!canEditGeneralFields"
                class="luggage-description"
                @input="onFieldChange"
              />
            </div>
          </div>
        </div>
      </section>
      <section class="solicitation-adm-section">
        <div
          class="d-flex align-center"
          style="gap: 10px;"
        >
          <span style="font-size: 14px;">N° SLT: <strong style="color:#FF821A;">{{ solicData.code || '-' }}</strong></span>
          <div class="badge-container">
            <div
              class="badge"
              :style="getBadgeColor(solicData.status)"
            >
              <span>{{ solicData.status || '-' }}</span>
            </div>
          </div>
        </div>
        <div
          class="d-flex flex-column"
          style="gap: 20px;"
        >
          <span>Ações</span>
          <div
            class="d-flex flex-column"
            style="gap: 32px;"
          >
            <div>
              <span
                :class="{'has-error': driverError}"
              >Atribuir motorista</span>
              <div
                class="d-flex my-4"
                style="gap: 5px;"
              >
                <v-menu
                  v-if="!selectedDriver || !selectedDriver.name"
                  v-model="menuDriver"
                  :close-on-content-click="false"
                  offset-y
                  min-width="400"
                  :disabled="isEditMode"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                      color="#E7E3FC1A"
                      class="add-people"
                      :class="{ disabled: isEditMode, 'has-error': driverError }"
                      size="40"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="18" color="#E7E3FC">{{ icons.mdiPlus }}</v-icon>
                    </v-avatar>
                  </template>
                  <v-card>
                    <v-text-field
                      v-model="driverSearch"
                      label="Buscar motorista"
                      outlined
                      dense
                      hide-details
                      autofocus
                      class="resource-search-field"
                    />
                    <v-list class="resource-list">
                      <v-list-item
                        v-for="driver in filteredDrivers"
                        :key="driver.id"
                        class="resource-list-item"
                        @click="handleSelectDriver(driver)"
                      >
                        <v-list-item-content>
                          <div class="resource-option d-flex align-center" style="gap: 10px;">
                            <v-avatar :size="40" class="v-avatar-light-bg success--text">
                              <v-img v-if="driver.url_photo" :src="driver.url_photo" />
                              <span v-else style="font-weight: 600;">{{ getInitials(driver) }}</span>
                            </v-avatar>
                            <div class="resource-option-content d-flex flex-column" style="font-size: 13px; gap: 5px;">
                              <div class="d-flex align-center" style="gap: 10px;">
                                <span>{{ driver.name }}</span>
                                <div v-if="driver.situation" class="badge" :style="returnStyleBasedOnStatus(driver.situation)">
                                  <span>{{ driver.situation }}</span>
                                </div>
                              </div>
                              <div class="badge" style="background-color: #56CA001A; color: #56CA00;">
                                <span>Disponível</span>
                              </div>
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <div>
                  <div
                    v-if="selectedDriver && selectedDriver.name"
                    class="d-flex align-center"
                    style="gap: 16px;"
                  >
                    <div
                      class="d-flex align-center"
                      style="gap: 10px;"
                    >
                      <v-avatar
                        :size="40"
                        class="v-avatar-light-bg success--text"
                      >
                        <v-img
                          v-if="selectedDriver && selectedDriver.url_photo"
                          :src="selectedDriver.url_photo"
                        />
                        <span
                          v-else
                          style="font-weight: 600;"
                        >
                          {{ getInitials(selectedDriver) }}
                        </span>
                      </v-avatar>
                      <div
                        class="d-flex flex-column"
                        style="font-size: 13px; gap: 6px;"
                      >
                        <div
                          class="d-flex align-center"
                          style="gap: 10px;"
                        >
                          <span>{{ selectedDriver.name }}</span>
                          <div class="badge-container">
                            <div
                              v-if="selectedDriver && selectedDriver.situation"
                              class="badge"
                              :style="returnStyleBasedOnStatus(selectedDriver.situation)"
                            >
                              <span>{{ selectedDriver.situation }}</span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex align-center"
                          style="gap: 6px;"
                        >
                          <div class="badge-container">
                            <div
                              class="badge"
                              style="background-color: #56CA001A; color: #56CA00;"
                            >
                              <span>Disponível</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-tooltip
                      bottom
                      color="#000000a1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="error"
                          v-bind="attrs"
                          :disabled="!canEditAssignments"
                          @click="clearDriver"
                          v-on="on"
                        >
                          <v-icon
                            color="error"
                            style="cursor: pointer;"
                          >
                            {{ icons.mdiDeleteOutline }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Remover motorista</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span
                :class="{ 'has-error': vehicleError }"
              >Atribuir veículo</span>
              <div
                class="d-flex my-4"
                style="gap: 5px;"
              >
                <v-menu
                  v-if="!selectedVehicle || !selectedVehicle.car_plate"
                  v-model="menuVehicle"
                  :close-on-content-click="false"
                  offset-y
                  min-width="400"
                  :disabled="!canEditAssignments"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                      color="#E7E3FC1A"
                      class="add-people"
                      :class="{ disabled: !canEditAssignments, 'has-error': vehicleError }"
                      size="40"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="18" color="#E7E3FC">{{ icons.mdiPlus }}</v-icon>
                    </v-avatar>
                  </template>
                  <v-card>
                    <v-text-field
                      v-model="vehicleSearch"
                      label="Buscar veículo"
                      outlined
                      dense
                      hide-details
                      autofocus
                      class="resource-search-field"
                    />
                    <v-list class="resource-list">
                      <v-list-item
                        v-for="vehicle in filteredVehicles"
                        :key="vehicle.id"
                        class="resource-list-item"
                        @click="handleSelectVehicle(vehicle)"
                      >
                        <v-list-item-content>
                          <div class="resource-option d-flex align-center" style="gap: 10px; text-transform: uppercase;">
                            <div style="padding: 8px; border-radius: 100%; background-color: #E7E3FC1A; display: flex; align-items: center; justify-content: center;">
                              <v-icon color="#E7E3FC">{{ icons.mdiCarOutline }}</v-icon>
                            </div>
                            <div class="resource-option-content d-flex flex-column" style="font-size: 13px; gap: 6px;">
                              <div class="d-flex align-center" style="gap: 10px;">
                                <span>{{ vehicle.car_plate }}</span>
                                <div class="badge" style="background-color: #56CA001A; color: #56CA00;"><span>Disponível</span></div>
                              </div>
                              <span>{{ vehicle.model }}, {{ vehicle.manufacturer && vehicle.manufacturer.name }}</span>
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
                <div>
                  <div
                    v-if="selectedVehicle && selectedVehicle.car_plate"
                    class="d-flex align-center"
                    style="gap: 16px;"
                  >
                    <div
                      class="d-flex align-center"
                      style="gap: 10px;"
                    >
                      <div style="padding: 8px; border-radius: 100%; background-color: #E7E3FC1A; display: flex; align-items: center; justify-content: center;">
                        <v-icon
                          color="#E7E3FC"
                        >
                          {{ icons.mdiCarOutline }}
                        </v-icon>
                      </div>
                      <div
                        class="d-flex flex-column"
                        style="font-size: 13px; gap: 6px; text-transform: uppercase;"
                      >
                        <div
                          class="d-flex align-center"
                          style="gap: 10px;"
                        >
                          <span>{{ selectedVehicle.car_plate }}</span>
                          <div class="badge-container">
                            <div
                              class="badge"
                              style="background-color: #56CA001A; color: #56CA00;"
                            >
                              <span>Disponível</span>
                            </div>
                          </div>
                        </div>
                        <span>{{ selectedVehicle.model }}, {{ selectedVehicle.manufacturer && selectedVehicle.manufacturer.name }}</span>
                      </div>
                    </div>
                    <v-tooltip
                      bottom
                      color="#000000a1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="error"
                          v-bind="attrs"
                          :disabled="!canEditAssignments"
                          @click="clearVehicle"
                          v-on="on"
                        >
                          <v-icon
                            color="error"
                            style="cursor: pointer;"
                          >
                            {{ icons.mdiDeleteOutline }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Remover veículo</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
              <div
                v-if="linkedSolicitationsList.length === 0"
              >
                <span>Deseja vincular outras solicitações a essa?</span>
                <v-radio-group
                  v-model="linkOtherSolicitations"
                  row
                  :disabled="!canEditAssignments"
                >
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </div>
              <div
                v-if="linkOtherSolicitations || linkedSolicitationsList.length > 0"
                class="d-flex flex-column"
                style="gap: 16px;"
              >
                <span>Solicitações vinculadas</span>
                <LinkedSolicitationCard
                  v-for="(linkedSolicitation, index) in linkedSolicitationsList || []"
                  :key="index"
                  :linked-solicitation-data="linkedSolicitation"
                  :is-edit-mode="isEditMode"
                  @solicitationUnlinked="handleLinkedSolicitationUnlinked"
                />
                <div
                  v-if="!solicData.is_child"
                  class="d-flex align-center"
                  style="gap: 10px;"
                >
                  <v-avatar
                    color="#E7E3FC1A"
                    class="add-people"
                    :class="{ disabled: !canEditAssignments }"
                    size="40"
                    @click="handleOpenLinkSolicitationsModal"
                  >
                    <v-icon
                      size="18"
                      color="#E7E3FC"
                    >
                      {{ icons.mdiPlus }}
                    </v-icon>
                  </v-avatar>
                </div>
              </div>
            </div>
            <div>
              <span>Atribuir status</span>
              <v-autocomplete
                v-model="currentStatus"
                class="mt-4"
                :items="statusList"
                label="Status"
                outlined
                style="max-width: 337px; font-weight: 500;"
                dense
                :disabled="!canEditAssignments"
              />
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="actions-area mt-4">
      <v-btn
        color="info"
        :disabled="isLoading || !canEditAssignments"
        @click="handleUpdateAssignments"
      >
        <span v-if="!isLoading">SALVAR ATRIBUIÇÕES</span>
        <v-progress-circular
          v-else
          indeterminate
          color="white"
          size="20"
          width="2"
          class="ma-0 pa-0"
        ></v-progress-circular>
      </v-btn>
      <slot name="actions"></slot>
    </div>

    <v-dialog
      v-model="showLinkSolicitationsModal"
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <LinkSolicitationsModal
        :parent-data="solicData"
        @close="showLinkSolicitationsModal = false"
        @linked="handleSolicitationsLinked"
      />
    </v-dialog>
  </div>
</template>

<script>
import axiosIns from '@/plugins/axios'
import {
  mdiCalendar, mdiCar, mdiCarOutline, mdiClockTimeEightOutline,
  mdiDeleteOutline,
  mdiLinkVariant,
  mdiMapMarkerOutline, mdiPlus,
} from '@mdi/js'
import {
  getBadgeColor, getVehicleBadgeColor, returnStyleBasedOnStatus,
} from '../../helpers/badgeHelpers'
import {
  formatAddress, formatDate, formatTime, formatTimeForPicker,
  getDriverFirstAndLastName, getInitials,
  getStatusExpectedOnBackend,
} from '../../helpers/formatHelpers'
import LinkSolicitationsModal from '../LinkSolicitationsModal.vue'
import LinkedSolicitationCard from '../LinkedSolicitationCard.vue'

export default {
  name: 'SolicitationTab',
  components: {
    LinkSolicitationsModal, LinkedSolicitationCard,
  },
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        mdiMapMarkerOutline,
        mdiPlus,
        mdiDeleteOutline,
        mdiCalendar,
        mdiClockTimeEightOutline,
        mdiCar,
        mdiLinkVariant,
        mdiCarOutline,
      },
      statusList: ['EM CHECKLIST', 'EM TRÂNSITO', 'CANCELADA', 'FINALIZADA', 'NÃO INICIADA'],
      passengers: [],
      isLoading: false,
      isLoadingParentsOrChildrensList: false,
      menuDriver: false,
      menuVehicle: false,
      driverSearch: '',
      vehicleSearch: '',
      driverError: false,
      vehicleError: false,
      linkedSolicitationsList: [],
      showLinkSolicitationsModal: false,
      selectedDriver: this.solicData.driver || null,
      selectedVehicle: this.solicData.vehicle || null,
      menuDepartureDate: false,
      menuDepartureTime: false,
      menuReturnDate: false,
      menuReturnTime: false,
      departureDate: this.solicData.departure_date_time ? new Date(this.solicData.departure_date_time).toISOString().substring(0, 10) : null,
      departureTime: this.solicData.departure_date_time ? this.formatTimeForPicker(this.solicData.departure_date_time) : null,
      returnDate: this.solicData.return_date_time ? new Date(this.solicData.return_date_time).toISOString().substring(0, 10) : null,
      returnTime: this.solicData.return_date_time ? this.formatTimeForPicker(this.solicData.return_date_time) : null,
      originalData: {},
      originalAssignments: {},
      hasChanges: false,
      linkOtherSolicitations: false,
      hasLuggage: this.solicData.has_luggage || false,
      luggageDetails: this.solicData.luggage_details || '',
      currentStatus: this.solicData.status ? this.solicData.status.toUpperCase() : '',
      responsibleOfCompany: {},
    }
  },
  computed: {
    filteredDrivers() {
      const search = this.driverSearch.trim().toLowerCase()

      return this.driversList.filter(driver => !search || String(driver.name || '').toLowerCase().includes(search))
    },
    filteredVehicles() {
      const search = this.vehicleSearch.trim().toLowerCase()

      return this.vehiclesList.filter(vehicle => {
        const searchableText = [
          vehicle.car_plate,
          vehicle.model,
          vehicle.manufacturer && vehicle.manufacturer.name,
        ].filter(Boolean).join(' ').toLowerCase()

        return !search || searchableText.includes(search)
      })
    },

    // Controla se campos gerais (datas, horários, motivo, bagagens) podem ser editados
    canEditGeneralFields() {
      // Se for solicitação filha, não pode editar campos gerais
      if (this.solicData.is_child) {
        return false
      }

      return this.isEditMode
    },

    // Controla se passageiros podem ser editados
    canEditPassengers() {
      // Passageiros podem ser editados tanto em solicitações pai quanto filhas
      return this.isEditMode
    },

    // Controla se atribuições (motorista/veículo) podem ser feitas
    canEditAssignments() {
      // Se for solicitação filha, não pode editar atribuições
      if (this.solicData.is_child) {
        return false
      }

      return !this.isEditMode
    },
  },
  created() {
    Promise.all([
      this.handleGetParentsOrChildrensList(),
      this.handleGetPassengers(),
      this.saveOriginalData(),
      this.getResponsibleCompany(),
    ])
  },
  methods: {
    getInitials,
    getDriverFirstAndLastName,
    returnStyleBasedOnStatus,
    getBadgeColor,
    getVehicleBadgeColor,
    formatAddress,
    formatDate,
    formatTime,
    formatTimeForPicker,

    async getResponsibleCompany() {
      if (!this.solicData.responsible_id) return

      try {
        const resCompany = await axiosIns.get(`/api/v1/solicitations/transport_solicitation_trip/get_responsible_user/${this.solicData.responsible_id}`)
        this.responsibleOfCompany = resCompany.data.data
      } catch (error) {
        const errorMessage = error.response.data.message
        this.showMessage({
          title: 'Erro ao carregar empresa responsável!',
          text: errorMessage || 'Não foi possível obter o responsável pela empresa.',
          icon: 'warning',
          timer: 5000,
        })
      }
    },

    async handleGetParentsOrChildrensList() {
      try {
        this.isLoadingParentsOrChildrensList = true
        const { data } = await axiosIns.get(`/api/v1/solicitations/transport_solicitation_trip/return_parent_or_children_of_solic/${this.solicData.id}`)
        this.linkedSolicitationsList = data.data || []
      } catch (error) {
        console.error('Error fetching linked solicitations:', error)
      } finally {
        this.isLoadingParentsOrChildrensList = false
      }
    },

    formatSourceAdress(locationData) {
      if (!locationData) return '-'

      const {
        address, number, district, city, state, zip_code: zipCode,
      } = locationData

      const addressParts = [
        address || '',
        number || '',
        district || '',
        city || '',
      ].filter(part => part.trim() !== '')

      const ufPart = state || ''
      const zipPart = zipCode ? `, ${zipCode}` : ''

      if (addressParts.length === 0 && !ufPart) return '-'

      return `${addressParts.join(', ')}${ufPart ? ` - ${ufPart}` : ''}${zipPart}`
    },

    handleOpenLinkSolicitationsModal() {
      this.showLinkSolicitationsModal = true
    },

    handleSolicitationsLinked() {
      this.showLinkSolicitationsModal = false
      this.handleGetParentsOrChildrensList()
    },

    handleLinkedSolicitationUnlinked(unlinkedSolicitationId) {
      this.linkedSolicitationsList = this.linkedSolicitationsList.filter(
        solic => solic.id !== unlinkedSolicitationId,
      )
      this.$emit('updateTable')
    },

    saveOriginalData() {
      this.originalData = {
        departureDate: this.departureDate,
        departureTime: this.departureTime,
        returnDate: this.returnDate,
        returnTime: this.returnTime,
        passengers: [...this.passengers],
        hasLuggage: this.hasLuggage,
        luggageDetails: this.luggageDetails,
      }
      this.originalAssignments = {
        selectedDriver: this.selectedDriver ? { ...this.selectedDriver } : null,
        selectedVehicle: this.selectedVehicle ? { ...this.selectedVehicle } : null,
        status: this.currentStatus,
      }
    },

    onFieldChange() {
      this.hasChanges = this.checkForChanges()
      if (this.hasChanges) {
        this.$emit('data-changed')
      }
    },

    checkForChanges() {
      return (
        this.departureDate !== this.originalData.departureDate
        || this.departureTime !== this.originalData.departureTime
        || this.returnDate !== this.originalData.returnDate
        || this.returnTime !== this.originalData.returnTime
        || JSON.stringify(this.passengers) !== JSON.stringify(this.originalData.passengers)
        || this.hasLuggage !== this.originalData.hasLuggage
        || this.luggageDetails !== this.originalData.luggageDetails
      )
    },

    closeModal() {
      this.$emit('closeModal')
    },
    async handleGetPassengers() {
      try {
        const { data } = await axiosIns.get(`/api/v1/solicitations/transport_solicitation_trip_user/get_by_trip_id/${this.solicData.id}`)

        this.passengers = (data.data || []).map(passenger => ({
          ...passenger,
          id: passenger.user_id || passenger.id,
        }))
      } catch (error) {
        console.error('Error fetching passengers:', error)
      } finally {
        this.isLoading = false
      }
    },
    async handleUpdateSolicitation() {
      try {
        this.isLoading = true
        const data = this.getData()
        const body = {
          departure_date_time: data.departure_date_time,
          return_date_time: data.return_date_time,
          passengers: data.passengers,
          driver_id: this.selectedDriver ? this.selectedDriver.id : null,
          vehicle_id: this.selectedVehicle ? this.selectedVehicle.id : null,
          status: getStatusExpectedOnBackend(data.status),
        }
        await axiosIns.put(`/api/v1/solicitations/transport_solicitation_trip/update/${this.solicData.id}`, body)
        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Solicitação atualizada com sucesso!',
          showConfirmButton: false,
          timer: 3000,
        })
        this.$emit('updateTable')
      } catch (error) {
        console.error('Error updating solicitation:', error)
      } finally {
        this.isLoading = false
      }
    },
    handleAddPassenger() {
      this.passengers.push({ id: null })
      this.onFieldChange()
    },
    removePassenger(index) {
      this.passengers.splice(index, 1)
      this.onFieldChange()
    },
    getUsersForPassengerField(currentPassengerId) {
      const selectedIds = this.passengers
        .map(p => p.id)
        .filter(id => id !== null && id !== currentPassengerId)

      return this.usersList
        .filter(user => !selectedIds.includes(user.id))
        .sort((a, b) => a.name.localeCompare(b.name))
    },
    validateForm() {
      return this.passengers.every(passenger => passenger.id !== null)
    },
    getData() {
      const departureDateTime = this.departureDate && this.departureTime
        ? `${this.departureDate}T${this.departureTime}:00.000Z`
        : null

      const returnDateTime = this.returnDate && this.returnTime
        ? `${this.returnDate}T${this.returnTime}:00.000Z`
        : null

      return {
        status: this.solicData.status,
        passengers: this.passengers.map(p => p.id).filter(id => id !== null),
        selectedDriver: this.selectedDriver,
        selectedVehicle: this.selectedVehicle,
        departure_date_time: departureDateTime,
        return_date_time: returnDateTime,
        reason: this.solicData.reason,
        has_luggage: this.solicData.has_luggage,
        luggage_details: this.solicData.luggage_details,
      }
    },
    handleSelectDriver(driver) {
      this.selectedDriver = driver
      this.driverError = false
      this.driverSearch = ''
      this.menuDriver = false
    },
    handleSelectVehicle(vehicle) {
      this.selectedVehicle = vehicle
      this.vehicleError = false
      this.vehicleSearch = ''
      this.menuVehicle = false
    },
    clearDriver() {
      this.selectedDriver = null
      this.driverSearch = ''
    },
    clearVehicle() {
      this.selectedVehicle = null
      this.vehicleSearch = ''
    },

    async saveSolicitationData() {
      try {
        this.isLoading = true
        const departureDateTime = this.departureDate && this.departureTime
          ? `${this.departureDate}T${this.departureTime}:00.000Z`
          : null

        const returnDateTime = this.returnDate && this.returnTime
          ? `${this.returnDate}T${this.returnTime}:00.000Z`
          : null

        const body = {
          departure_date_time: departureDateTime,
          return_date_time: returnDateTime,
          passengers: this.passengers.map(p => p.id).filter(id => id !== null),
          has_luggage: this.hasLuggage,
          luggage_details: this.luggageDetails,
        }

        await axiosIns.put(`/api/v1/solicitations/transport_solicitation_trip/update/${this.solicData.id}`, body)

        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Dados da solicitação atualizados com sucesso!',
          showConfirmButton: false,
          timer: 3000,
        })

        this.saveOriginalData()
        this.hasChanges = false

        return true
      } catch (error) {
        console.error('Error updating solicitation data:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao atualizar dados da solicitação.',
        })

        return false
      } finally {
        this.isLoading = false
      }
    },

    async handleUpdateAssignments() {
      this.driverError = !this.selectedDriver
      this.vehicleError = !this.selectedVehicle
      if (this.driverError || this.vehicleError) return

      try {
        this.isLoading = true
        const body = {
          driver_id: this.selectedDriver ? this.selectedDriver.id : null,
          vehicle_id: this.selectedVehicle ? this.selectedVehicle.id : null,
          status: getStatusExpectedOnBackend(this.currentStatus),
        }

        await axiosIns.put(`/api/v1/solicitations/transport_solicitation_trip/update/${this.solicData.id}`, body)

        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Atribuições atualizadas com sucesso!',
          showConfirmButton: false,
          timer: 3000,
        })

        this.$emit('updateTable')
        this.$emit('close')
        this.saveOriginalData()
      } catch (error) {
        const errorMessage = error.response.data.message
        this.$swal({
          title: 'Não foi possível atribuir o motorista',
          icon: 'warning',
          text: errorMessage,
          showConfirmButton: false,
          timer: 5000,
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.add-people {
    cursor: pointer;
    transition: opacity 0.3s ease;
  }
.add-people:hover{
  opacity: 0.8;
}
.solicitation-adm-section {
  color: #E7E3FC;
  font-weight: 600;
  font-size: 14px;
  margin-top: 35px;
  flex: 1;
  max-width: 50%;
  display: flex;
  flex-direction: column;
  gap: 23px;
}
.add-people.has-error {
  border: 1px solid #FF4C51;
}
span.has-error {
  color: #FF4C51;
}
.badge {
  padding: 3px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-weight: 600;
  text-align: center;
  font-size: 11px;
}
.badge-container {
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.solicitation-tab {
  width: 100%;
}

.content-area {
  width: 100%;
  display: flex;
  gap: 55px;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 300px;
}

.solicitation-section {
  flex: 1;
  max-width: 50%;
}

.solicitation-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.location-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-weight: 600;
  font-size: 15px;
  text-align: left;
}

.location-display {
  width: 100%;
}

.loc-card-display {
  background-color: #3B355A;
  border-radius: 10px;
  color: #E7E3FC;
  padding: 16px;
  width: 100%;
}

.loc-icon-wrapper {
  background: #E7E3FC1A;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  padding: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loc-card-title {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 4px;
}

.loc-card-address {
  font-weight: 500;
  font-size: 12px;
  color: #E7E3FC;
}

.trip-form-section {
  display: flex;
  flex-direction: column;
  margin-top: 22px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-time-row {
  display: flex;
  gap: 16px;
  width: 100%;
}

.date-field,
.time-field {
  flex: 1;
}

.description-field,
.passengers-field,
.luggage-description {
  width: 100%;
}

.luggage-checkbox {
  margin: 0;
  padding: 0;
}

.passengers-section {
  width: 100%;
}

.add-passenger {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer
}
.add-passenger:hover {
  opacity: 0.8;
  transition: opacity 0.3s ease;
}
.add-passenger.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.actions-area {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.resource-search-field {
  margin: 16px 16px 8px;
  width: calc(100% - 32px);
}

.resource-list {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 8px 8px;
}

.resource-list-item {
  min-height: 76px !important;
  padding: 12px 8px !important;
}

.resource-option {
  min-height: 52px;
}

.resource-option-content .badge {
  align-self: flex-start;
  width: fit-content;
  white-space: nowrap;
}

.vehicle-disabled {
  pointer-events: none !important;
  cursor: not-allowed !important;
}

.vehicle-disabled:hover {
  background-color: transparent !important;
}

.vehicle-disabled span:not(.badge span),
.vehicle-disabled .v-icon {
  opacity: 0.5 !important;
}

.vehicle-disabled .badge {
  opacity: 1 !important;
}

/* Responsividade */
@media (max-width: 1200px) {
  .content-area {
    flex-direction: column;
    gap: 40px;
  }

  .solicitation-section,
  .solicitation-adm-section {
    flex: none;
    max-width: 100%;
    width: 100%;
  }

  .solicitation-adm-section {
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .content-area {
    gap: 30px;
  }

  .date-time-row {
    flex-direction: column;
    gap: 12px;
  }

  .date-field,
  .time-field {
    width: 100%;
  }
}
</style>
